import { UserManager } from 'oidc-client-ts';
import { settings } from '../../features/user/userManager';

function SilentRenew(): JSX.Element {
  new UserManager(settings).signinSilentCallback().catch((err) => {
    console.error(err);
  });
  return <div>SilentRenewComponent...</div>;
}
export default SilentRenew;
